import React, { Component } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { isEmpty } from "lodash"
import { TableHead, TableBody, TableFooter, TableRow, TableCell } from '@material-ui/core';

class PreviewFacture extends Component {
    state = { 
        src : ""
    }

    componentDidMount = async () => {
        // const { shop, SHOPS, update } = this.props
        // if(!isEmpty(shop.photo)) {
        //     this.setState({ src : shop.photo[0].data_uri })

        // } else if( update && shop.oldLogo && shop.oldLogo.filename ){
        //     console.log(shop, "found old photo")
        //     await this.props.getPhoto(shop.id, shop.oldLogo.filename)

        //     this.setState({ src : SHOPS[shop.id].src })
        // } 
    }

    
    render() {
        return (
            <CardLayout>
                {/* <div className="pull-right">
                    <button className="btn btn-info" onClick={() => window.print()}>Imprimer</button>
                </div> */}
                <div id="section-to-print" style={{ border: "1px solid black", padding:"25px 15px 10px"}} >
                    <div className="card-text">
                        <div className="row m-5">
                            <div className="col-xs-12">
                                {this.props.shop.logo &&
                                <div className="logo">
                                    <img src={`/stocks/photos/${this.props.shop.logo.filename}`} alt=""/>
                                </div>
                                }
                               
                                <h4>{this.props.shop.name}</h4>
                                <span>{this.props.shop.address}</span><br/>
                                <span>{this.props.shop.city}</span><br/>
                                <span>{this.props.shop.country}</span><br/>

                            </div>

                            <div className="col-xs-12 text-right">
                                Client : <br/>
                                <address>
                                    <span>Prénom Nom</span><br/>
                                    <span>Téléphone</span><br/>
                                    <span>Adresse - Ville</span><br/>
                                    <span>Pays</span><br/>
                                </address>
                            </div>
                        
                            <h4>Facture n° XXXXXXXX-XXXX...</h4>
                            <h5>
                                Date :  {(new Date()).toLocaleString('fr-FR')}
                            </h5>
                        </div>
                    
                        <hr/>
                        <div style={{minHeight: "40vh"}}>
                            <TableLayout className="text-right">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="text-left">Produit</TableCell>
                                        <TableCell>Quantité</TableCell>
                                        <TableCell>PU HT</TableCell>
                                        <TableCell>Total HT</TableCell>
                                        <TableCell colSpan={2}>Remise</TableCell>
                                        <TableCell>TVA</TableCell>
                                        {/* <TableCell>PU Vente</TableCell> */}
                                        <TableCell>Total TTC</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                        <TableCell>.....</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={8}></TableCell>
                                    </TableRow>
                                </TableBody>

                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={2}></TableCell>
                                        <TableCell>TOTAL</TableCell>
                                        <TableCell className="f-700">
                                            xxxxx
                                        </TableCell>
                                        <TableCell colSpan={2} className="f-700">
                                            - xxxxx
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell className="f-700">
                                            xxxxxxxxx
                                        </TableCell>
                                        
                                    </TableRow>
                                    
                                </TableFooter>
                            </TableLayout>     
                        </div>
                    </div>

                    <div className="footer">
                        <div className="text-center bottom-info">{this.props.shop.bottom_info}</div>
                        <div className="text-center bottom-info">{this.props.shop.bottom_info2}</div>
                        <div className="text-center bottom-info">{this.props.shop.bottom_info3}</div>
                    </div>
                </div>
            </CardLayout>
        
        );
    }
}

export default PreviewFacture;